import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Icons } from "../../../shared/icons/icons";
import "./NotFoundPage.css";

const REDIRECT_SECONDS = 10;
const REDIRECT_DURATION = REDIRECT_SECONDS * 1000;
const CIRCLE_LENGTH = 138;
const LOGO_SRC = "assets/images/logo/Logo.png";

export default function NotFoundPage() {
  const navigate = useNavigate();

  const redirectTimerRef = useRef(null);
  const animationFrameRef = useRef(null);

  const [timeLeftMs, setTimeLeftMs] = useState(REDIRECT_DURATION);

  const secondsLeft = Math.ceil(timeLeftMs / 1000);
  const progress = Math.max(timeLeftMs / REDIRECT_DURATION, 0);
  const dashOffset = CIRCLE_LENGTH - CIRCLE_LENGTH * progress;

  useEffect(() => {
    const startTime = performance.now();

    const updateCountdown = () => {
      const elapsed = performance.now() - startTime;
      const remaining = Math.max(REDIRECT_DURATION - elapsed, 0);

      setTimeLeftMs(remaining);

      if (remaining > 0) {
        animationFrameRef.current = window.requestAnimationFrame(updateCountdown);
      }
    };

    animationFrameRef.current = window.requestAnimationFrame(updateCountdown);

    redirectTimerRef.current = window.setTimeout(() => {
      navigate("/", { replace: true });
    }, REDIRECT_DURATION);

    return () => {
      window.clearTimeout(redirectTimerRef.current);
      window.cancelAnimationFrame(animationFrameRef.current);
    };
  }, [navigate]);

  const handleGoHome = () => {
    navigate("/", { replace: true });
  };

  return (
    <main className="not-found-page">
      <div className="not-found-page__decor not-found-page__decor--left" />
      <div className="not-found-page__decor not-found-page__decor--right" />

      <section className="not-found-page__card">
        <span className="not-found-page__brand" aria-label="Clínica Dionara Krause">
          <img src={LOGO_SRC} alt="Clínica Dionara Krause" />
        </span>

        <div className="not-found-page__badge">
          <Icons.Sparkles />
          Página não encontrada
        </div>

        <h1>Ops, esse caminho não existe.</h1>

        <p>
          Parece que você tentou acessar uma página que não está disponível.
          Vamos te levar de volta para a página inicial da Clínica Dionara
          Krause.
        </p>

        <div className="not-found-page__countdown" aria-live="polite">
          <div className="not-found-page__countdown-ring">
            <svg viewBox="0 0 52 52" aria-hidden="true">
              <circle
                className="not-found-page__countdown-track"
                cx="26"
                cy="26"
                r="22"
              />

              <circle
                className="not-found-page__countdown-progress"
                cx="26"
                cy="26"
                r="22"
                style={{
                  strokeDashoffset: dashOffset,
                }}
              />
            </svg>

            <span>{secondsLeft}</span>
          </div>

          <div className="not-found-page__countdown-text">
            <strong>Voltando para o início</strong>
            <small>
              Redirecionamento automático em {secondsLeft}{" "}
              {secondsLeft === 1 ? "segundo" : "segundos"}
            </small>
          </div>
        </div>

        <button
          type="button"
          className="not-found-page__button"
          onClick={handleGoHome}
        >
          Voltar agora
          <Icons.ArrowRight />
        </button>
      </section>
    </main>
  );
}